export const auditEngagementsKeys = {
  all: () => ["auditEngagements"],
  withParameters: (filters: any, order: any, page: number, perPage: number) => [
    ...auditEngagementsKeys.all(),
    { filters, order },
    page,
    perPage
  ]
};
